module.exports = __webpack_public_path__ + "img/empty-message-box_superlive.8c8c9053.svg";